import { Action, MemoizedSelector, Store } from '@ngrx/store';
import { take } from 'rxjs';
import { appFeature, AppState } from './app.reducer';

// Defined in index.html
declare const oca: undefined | {
  mainLanguage: string;
  translations: {
    // key: language
    [key: string]: {
      // key: translation key
      [key: string]: string;
    };
  };
  initialState: { [appFeature.name]: AppState };
};

export function getInitialState(): typeof oca | undefined {
  return typeof oca === 'undefined' ? undefined : oca;
}

/**
 * If equalFn returns true, this indicates that the action should not be dispatched because the expected item is already in the state
 */
export function maybeDispatch<T>(store: Store,
                                 selector: MemoizedSelector<unknown, T>,
                                 equalFn: (element: T) => boolean,
                                 action: Action) {
  store.select(selector).pipe(take(1)).subscribe(result => {
    if (!equalFn(result)) {
      store.dispatch(action);
    }
  });
}
